import React, { useState } from 'react';
import { logEvent } from '@firebase/analytics';
import {analytics} from '../config/firebase-logging';

function MultipleChoice(props) {
    const [output, setOutput] = useState("");
    const [activeIndex, setActiveIndex] = useState(-1);
    const [color, setColor] = useState("");
    function handleSelect(event, index) {
        if (process.env.REACT_APP_ENVIRONMENT === "production") {
            logEvent(analytics, 'career_interaction')
        }
        setColor('')
        setActiveIndex(index);
        if (event.target.textContent === props.choices[props.ans]) {
            setColor('green-bg')
        } else {
            setColor('red-bg')
        }
        setOutput(props.result[index]);

    }

    return (
        <div className='mc-question'>
            <strong><p className='description' style={{maxWidth:"800px", marginLeft: "auto", marginRight: "auto", textAlign:"left"}}>{props.problem}</p></strong>
            <div className='choice-container'>
                {props.choices.map((choice, index) => {
                    return (<div key={index} className={activeIndex === index ? 'choice ' + color : 'choice'} onClick={(event) => handleSelect(event, index)}>{choice}</div>);
                })}
            </div>
            {output && <p style={{textAlign: "left", maxWidth: "700px", marginLeft: "auto", marginRight: "auto"}}>{output}</p>}
        </div>
    );
}

export default MultipleChoice;